
export default{
  viewMode:{
    PROTOTYPE:"prototype",
    DEVELOP:"develop"
  },
  numberBoundary:{
    MIN:-999999999999999,
    MAX:999999999999999,
  }
}